<template lang="pug">
.visualizar-regiao-modal(
    :class='isLoading ? "--loading" : ""'
    :style="{ width : '500px'}")

    //- .linha
    //-     .coluna
    //-         | Nome: {{ regiao.nome }}
    .linha
        .coluna
            collapse-component(title='Dados da região', :isBasic='true')
                .linha
                    .coluna
                        | Data de cadastro: {{ regiao.dataCadastro  | data }}
                .linha
                    .coluna
                        | Quantidade de municípios: {{ regiao.quantidadeMunicipios }}
    .linha
        .coluna
            collapse-component(title='Municípios', :isBasic='true')
                .municipios-content
                    .linha
                        .coluna
                            filter-basic-component(
                                @filtro:pesquisar='pesquisar($event)',
                            )
                    .linha
                        .coluna
                            .municipios-box(v-if='dadosRegiao?.municipios',
                                :style='[ dadosRegiao?.municipios.length <= 7 ? { columnCount: "1" } : { columnCount: "3" } ] ',
                            )
                                chip-component(
                                    :style='{ margin: "5px" }'
                                    v-for='(municipio, index) in dadosRegiao.municipios',
                                    :key='index',
                                    :label='municipio.nome'
                                )
                    .linha
                        .coluna(:style="[ { display : 'flex' }, { justifyContent : 'flex-end' } ]") Total de municípios: {{ dadosRegiao?.municipios.length }}.
    .linha
        .coluna
            collapse-component(title='Gerentes vinculados', :isBasic='true')
                .linha(v-for="( gerente, index ) in dadosRegiao?.vinculados"
                    :key='index'
                )   {{ gerente.nome }}
</template>

<script>
import {
    buscarPorId
} from '@/services/regiaoAnalise.service';

import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue';

export default {

    name: 'VisualizarRegiaoModal',

    components: {
        FilterBasicComponent
    },

    props: {
        regiao: Object
    },

    data() {
        return {
            isLoading: false,
            dadosRegiao: null
        };
    },

    async created() {
        this.isLoading = true;
        this.dadosRegiao = await this.getRegiao();
        this.isLoading = false;
    },

    methods: {

        cancelar() {
            this.$emit('onClose');
        },

        async getRegiao() {
            return await buscarPorId(this.regiao.id)
        },

        async pesquisar(searchValue) {
            if (searchValue === '') {
                this.isLoading = true;
                this.dadosRegiao = await this.getRegiao();
                this.isLoading = false;
            } else {
                this.isLoading = true;
                let filteredMunicipios = this.dadosRegiao.municipios.filter(municipio => municipio.nome.toLowerCase().includes(searchValue))
                this.dadosRegiao.municipios = filteredMunicipios;
                this.isLoading = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.visualizar-regiao-modal {

    width: 500px;
    max-height: 500px;
    overflow-y: auto;

}

.municipios-content {
    width: 100%;
}

.municipios-box {
    max-height: 180px;
    overflow-y: auto;

    column-count: 3;
}

.visualizar-regiao-modal::-webkit-scrollbar {
    width: 3px;
}

.visualizar-regiao-modal::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.visualizar-regiao-modal::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
}

.municipios-box::-webkit-scrollbar {
    width: 3px;
}

.municipios-box::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.municipios-box::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
}

.visualizar-regiao-modal .--loading {
    background-color: var(--primary-smoke);
    background-image: url('../../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
}
</style>
